module.exports = __webpack_public_path__ + "img/quality-03-landscape.2cd84842.jpg";